import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, IconButton as MuiIconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Container = styled(Grid)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  ".MuiTypography-root": {
    width: "160px",
    cursor: "default",
  },

  // actions buttons
  "& > button > svg": {
    fontSize: "20px",
  },
});

export const IconButton = styled(MuiIconButton)({
  "& > svg": {
    width: "30px",
  },
});

export const FilesContainer = styled(Grid)({
  display: "flex",
  flex: "1",
  gap: "5px",
});

export const Actions = styled(Grid)({
  display: "flex",

  "& > .MuiButtonBase-root": {
    padding: "2px",
  },
});

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
}));
